// extracted by mini-css-extract-plugin
module.exports = {"card":"LandingPageCard_card__uk3sw"};